import React, { useContext } from 'react';
import tw from 'twin.macro';
import { Icon } from '../icon';
import { AppContext } from '../context';
import { SearchIcon } from 'icons';
import { SearchMenu } from '../menus';

export const Search = () => {
  const { slideIn, setSlideIn } = useContext(AppContext);

  return (
    <div css={[tw`cursor-pointer`]}>
      <Icon
        Type={SearchIcon}
        label='Zoeken'
        onClick={() => {
          setSlideIn({ ...slideIn, active: true, fullwidth: false, Component: SearchMenu });
        }}
        tw='cursor-pointer'
      />
    </div>
  );
};
